module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAAAXNSR0IArs4c6QAAARRJREFUKFNt0bFKxEAQBuB/jkDeIY8gWFoIFoKVIAgWgoKgIbMbsBGu9DECFikkegrKdsqVimCjjVgfaGebTSOJETPeHlzw4k33L9/uMjPEzO9ENLTWHhljftApYuZtIjoDcG2tVcaY+q8hF6Io2uz1epcAbuu6PsiyrJqiCXAVx/Fq0zQ3AB7KstwZDAaf7rwFLjDzEhHdichrVVXrDs0Ah7TWCyLyDGBkrV35BxwKwzDwPG80fvRjLlBKLQJ4AfA074tlEbkXkccgCDZmgNZ6TURcJ0Pf9/eSJPlqgdZ6S0QuRMQURcHTgU2AUmoXwCkRnYvIYZqm3+2gmHmfiFIiOsnzvN/dByml3gBcjW8ddxfl8i+ARHqayCtH9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_gengduo_nor.png
// module id = xGCF
// module chunks = 1